module.exports = __webpack_public_path__ + "img/phil-print.42d92e83.png";